import React, { useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { Input } from "stories/forms";
import { useAppContext } from "contexts/AppContext"
import { getOptionStateLabel } from "./optionStateLabels"

const OptionStateInput = ({label, name="state", onChange, value, allOption = true, disabled}) => {
  const { t } = useTranslation();
  const { enums } = useAppContext()
  
  const getInputOptions = useCallback(() => {
    const inputOptions = enums?.options?.option?.option_state;
    return inputOptions && inputOptions.map(obj => {
      return (
        <option key={obj.key} value={obj.key}>
          {getOptionStateLabel(t, obj.key) || t(obj.value, obj.value)}
        </option>
      )
    })
  }, [enums, t])
  
  return (
    <Input label={label ? label : t("option_state_input_label", "State")} type="select" name={name} onChange={onChange} value={value} disabled={disabled}>
      { allOption && (<option value="">{t("all_option", "All")}</option>)}
      {getInputOptions()}
    </Input>
  )
  
  
}

export default OptionStateInput;
